export const LocalStorage = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  CVM_ANALYTICS:"CVM_ANALYTICS"
};
